import date from 'date-and-time';

const utcDayFormat = 'YYYY-MM-DD';

/** Midnight UTC of the UTC calendar day that contains `instant`. */
const startOfUtcDay = (instant: Date): Date =>
  new Date(Date.UTC(instant.getUTCFullYear(), instant.getUTCMonth(), instant.getUTCDate()));

/**
 * The latest day that has complete chart data. The data is daily in UTC, and
 * the current UTC day is not complete, so this is the day before the UTC day
 * of `now`. musicapi refuses a future UTC day and clamps the current one. It never uses the local calendar: just after local midnight east
 * of UTC, the local "yesterday" is still today in UTC.
 */
export const latestCompleteUtcDay = (now: Date = new Date()): Date => date.addDays(startOfUtcDay(now), -1, true);

/** The oldest UTC day a plan with `historyDaysLimit` days can open, counted back from UTC today like musicapi does. */
export const oldestAllowedUtcDay = (now: Date, historyDaysLimit: number): Date =>
  date.addDays(startOfUtcDay(now), -historyDaysLimit, true);

/** Formats a UTC midnight as its UTC calendar day (`YYYY-MM-DD`), whatever the local time zone is. */
export const formatUtcDay = (utcMidnight: Date): string => date.format(utcMidnight, utcDayFormat, true);
